import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../assets/RykenLabsLogo.png';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  return (
    <nav className="bg-white shadow-lg border-b border-sky-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo and brand name */}
          <Link to="/" className="flex items-center space-x-3">
            <img src={logo} alt="Ryken Labs" className="w-8 h-8" />
            <span className="text-2xl font-bold glow-text">Ryken Labs</span>
          </Link>
          
          {/* Desktop menu */}
          <div className="hidden md:flex space-x-8">
            <Link 
              to="/" 
              className={`${isActive('/') ? 'font-bold' : 'hover:opacity-80'} transition-opacity duration-200`}
              style={{ color: isActive('/') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
            >
              Home
            </Link>
            <Link
              to="/features"
              className={`${isActive('/features') ? 'font-bold' : 'hover:opacity-80'} transition-opacity duration-200`}
              style={{ color: isActive('/features') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
            >
              Features
            </Link>
            <Link
              to="/download"
              className={`${isActive('/download') ? 'font-bold' : 'hover:opacity-80'} transition-opacity duration-200`}
              style={{ color: isActive('/download') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
            >
              Download
            </Link>
            <Link
              to="/about"
              className={`${isActive('/about') ? 'font-bold' : 'hover:opacity-80'} transition-opacity duration-200`}
              style={{ color: isActive('/about') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
            >
              About
            </Link>
            <Link 
              to="/privacy" 
              className={`${isActive('/privacy') ? 'font-bold' : 'hover:opacity-80'} transition-opacity duration-200`}
              style={{ color: isActive('/privacy') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
            >
              Privacy
            </Link>
            <Link 
              to="/terms" 
              className={`${isActive('/terms') ? 'font-bold' : 'hover:opacity-80'} transition-opacity duration-200`}
              style={{ color: isActive('/terms') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
            >
              Terms
            </Link>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="focus:outline-none" style={{ color: 'var(--ryken-accent)' }}>
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        
        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-sky-200">
            <div className="flex flex-col space-y-3">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className={`${isActive('/') ? 'font-bold' : ''} py-2`}
                style={{ color: isActive('/') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
              >
                Home
              </Link>
              <Link
                to="/features"
                onClick={() => setIsMenuOpen(false)}
                className={`${isActive('/features') ? 'font-bold' : ''} py-2`}
                style={{ color: isActive('/features') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
              >
                Features
              </Link>
              <Link
                to="/download"
                onClick={() => setIsMenuOpen(false)}
                className={`${isActive('/download') ? 'font-bold' : ''} py-2`}
                style={{ color: isActive('/download') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
              >
                Download
              </Link>
              <Link
                to="/about"
                onClick={() => setIsMenuOpen(false)}
                className={`${isActive('/about') ? 'font-bold' : ''} py-2`}
                style={{ color: isActive('/about') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
              >
                About
              </Link>
              <Link 
                to="/privacy" 
                onClick={() => setIsMenuOpen(false)}
                className={`${isActive('/privacy') ? 'font-bold' : ''} py-2`}
                style={{ color: isActive('/privacy') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
              >
                Privacy
              </Link>
              <Link 
                to="/terms" 
                onClick={() => setIsMenuOpen(false)}
                className={`${isActive('/terms') ? 'font-bold' : ''} py-2`}
                style={{ color: isActive('/terms') ? 'var(--ryken-secondary)' : 'var(--ryken-accent)' }}
              >
                Terms
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;